import { render, staticRenderFns } from "./ErpDlsOrderEdit.vue?vue&type=template&id=6e884ef2&scoped=true&"
import script from "./ErpDlsOrderEdit.vue?vue&type=script&lang=js&"
export * from "./ErpDlsOrderEdit.vue?vue&type=script&lang=js&"
import style0 from "./ErpDlsOrderEdit.vue?vue&type=style&index=0&id=6e884ef2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e884ef2",
  null
  
)

export default component.exports